/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function PrepositionQualityStandard(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76 11.3723C76 3.25003 67.0582 -1.09632 59.8992 2.74034C53.9693 5.91831 47.1948 8.40231 40.0004 8.40231C32.8058 8.40231 26.0312 5.91827 20.1011 2.74023C12.942 -1.09649 4 3.24994 4 11.3723V68.6272C4 76.7495 12.9419 81.0959 20.1009 77.2593C26.0309 74.0812 32.8056 71.5972 40 71.5972C47.1944 71.5972 53.969 74.0812 59.899 77.2592C67.058 81.0959 76 76.7494 76 68.6271V11.3723Z"
        fill="#F7F7F8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76 11.3723C76 3.25003 67.0582 -1.09632 59.8992 2.74034C53.9693 5.91831 47.1948 8.40231 40.0004 8.40231C32.8058 8.40231 26.0312 5.91827 20.1011 2.74023C12.942 -1.09649 4 3.24994 4 11.3723V68.6272C4 76.7495 12.9419 81.0959 20.1009 77.2593C26.0309 74.0812 32.8056 71.5972 40 71.5972C47.1944 71.5972 53.969 74.0812 59.899 77.2592C67.058 81.0959 76 76.7494 76 68.6271V11.3723Z"
        fill="url(#paint0_radial_15594_8453)"
        fillOpacity="0.25"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.6536 28.8877L41.8447 27.3469C41.3299 26.9077 40.6754 26.668 39.9987 26.668C39.3221 26.668 38.6676 26.9092 38.1528 27.3484L36.3438 28.8892C35.8882 29.2778 35.3215 29.5127 34.7245 29.5604L32.3571 29.7486C31.6825 29.8017 31.0491 30.0936 30.5704 30.5718C30.0917 31.05 29.7991 31.6832 29.7451 32.3577L29.5555 34.7268C29.5081 35.3239 29.2755 35.8898 28.8859 36.3462L27.3451 38.1567C26.9068 38.6713 26.666 39.3253 26.666 40.0013C26.666 40.6773 26.9068 41.3313 27.3451 41.8459L28.8859 43.6564C29.2742 44.1117 29.509 44.6779 29.557 45.2744L29.7466 47.6435C29.8001 48.3175 30.0919 48.9505 30.5697 49.4289C31.0475 49.9073 31.6801 50.1998 32.3541 50.254L34.7245 50.4437C35.3218 50.4906 35.889 50.725 36.3453 51.1134L38.1528 52.6543C38.6676 53.0934 39.3221 53.3346 39.9987 53.3346C40.6754 53.3346 41.3299 53.0934 41.8447 52.6543L43.6536 51.1134C44.1095 50.7253 44.6761 50.491 45.2729 50.4437L47.6433 50.254C48.3171 50.1999 48.9495 49.9075 49.4273 49.4294C49.9051 48.9513 50.197 48.3187 50.2508 47.6449L50.4404 45.2744C50.4879 44.6773 50.7234 44.1113 51.1116 43.655L52.6523 41.8459C53.0915 41.3311 53.3327 40.6765 53.3327 39.9998C53.3327 39.3231 53.0915 38.6686 52.6523 38.1537L51.1116 36.3462C50.7234 35.8913 50.4879 35.3239 50.439 34.7268L50.2508 32.3562C50.1966 31.6824 49.9043 31.05 49.4263 30.5722C48.9482 30.0943 48.3156 29.8024 47.6419 29.7486L45.2714 29.5589C44.6759 29.51 44.1099 29.2759 43.6536 28.8877ZM38.6661 44.5536L45.885 37.3347L43.9994 35.4491L38.6661 40.7824L35.9994 38.1157L34.1138 40.0013L38.6661 44.5536Z"
        fill="#141A1F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.6536 28.8877L41.8447 27.3469C41.3299 26.9077 40.6754 26.668 39.9987 26.668C39.3221 26.668 38.6676 26.9092 38.1528 27.3484L36.3438 28.8892C35.8882 29.2778 35.3215 29.5127 34.7245 29.5604L32.3571 29.7486C31.6825 29.8017 31.0491 30.0936 30.5704 30.5718C30.0917 31.05 29.7991 31.6832 29.7451 32.3577L29.5555 34.7268C29.5081 35.3239 29.2755 35.8898 28.8859 36.3462L27.3451 38.1567C26.9068 38.6713 26.666 39.3253 26.666 40.0013C26.666 40.6773 26.9068 41.3313 27.3451 41.8459L28.8859 43.6564C29.2742 44.1117 29.509 44.6779 29.557 45.2744L29.7466 47.6435C29.8001 48.3175 30.0919 48.9505 30.5697 49.4289C31.0475 49.9073 31.6801 50.1998 32.3541 50.254L34.7245 50.4437C35.3218 50.4906 35.889 50.725 36.3453 51.1134L38.1528 52.6543C38.6676 53.0934 39.3221 53.3346 39.9987 53.3346C40.6754 53.3346 41.3299 53.0934 41.8447 52.6543L43.6536 51.1134C44.1095 50.7253 44.6761 50.491 45.2729 50.4437L47.6433 50.254C48.3171 50.1999 48.9495 49.9075 49.4273 49.4294C49.9051 48.9513 50.197 48.3187 50.2508 47.6449L50.4404 45.2744C50.4879 44.6773 50.7234 44.1113 51.1116 43.655L52.6523 41.8459C53.0915 41.3311 53.3327 40.6765 53.3327 39.9998C53.3327 39.3231 53.0915 38.6686 52.6523 38.1537L51.1116 36.3462C50.7234 35.8913 50.4879 35.3239 50.439 34.7268L50.2508 32.3562C50.1966 31.6824 49.9043 31.05 49.4263 30.5722C48.9482 30.0943 48.3156 29.8024 47.6419 29.7486L45.2714 29.5589C44.6759 29.51 44.1099 29.2759 43.6536 28.8877ZM38.6661 44.5536L45.885 37.3347L43.9994 35.4491L38.6661 40.7824L35.9994 38.1157L34.1138 40.0013L38.6661 44.5536Z"
        fill="url(#paint1_radial_15594_8453)"
        fillOpacity="0.5"
      />
      <defs>
        <radialGradient
          id="paint0_radial_15594_8453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.63636 12.219) rotate(32.5192) scale(140.965 67.6359)"
        >
          <stop stopColor="#01ECFF" />
          <stop offset="1" stopColor="#E4B6FF" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_15594_8453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.0128 30.8346) rotate(42.9597) scale(56.0053 26.8297)"
        >
          <stop stopColor="#19BCC9" />
          <stop offset="1" stopColor="#E4B6FF" />
        </radialGradient>
      </defs>
    </svg>
  )
}

PrepositionQualityStandard.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default PrepositionQualityStandard
